module.exports = __webpack_public_path__ + "df63764fc4cdd766ac04e0984c0f0dd3.pdf";